import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { List, Box, Tooltip, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useGetFeedbacksQuery } from '../feedbackApiSlice';
import { selectCurrentUser, setFeedbackStatus } from '../../Auth/authSlice';
import FeedbackItem from './FeedbackItem';
import { groupFeedbacksByDate } from '../utility/utilities';
import StyledDateDivider from './StyledDateDivider';
import { Element } from 'react-scroll';
import { KeyboardArrowDown } from '@mui/icons-material';
import { SkeletonFeedbackList } from '../skeletons/SkeletonFeedbackList';

const FeedbackList = ({ setEditingFeedback, showScrollButton, setShowScrollButton, inputHeight }) => {
  const user = useSelector(selectCurrentUser);
  const { data: feedbackData, isLoading, error, refetch } = useGetFeedbacksQuery(undefined,{refetchOnMountOrArgChange:true});
  const listRef = useRef(null);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(setFeedbackStatus(false));
  }, [dispatch]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight + 300;
    }
    dispatch(setFeedbackStatus(false));
  }, [feedbackData, dispatch]);

  const groupedFeedbacks = groupFeedbacksByDate(feedbackData);

  const handleScroll = () => {
    if (listRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 65;
      setShowScrollButton(!isAtBottom);
    }
  };
  const scrollToBottom = () => {
    if (listRef.current) {
      listRef.current.scrollTo({
        top: listRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  };
  useLayoutEffect(() => {
    scrollToBottom();
  }, [inputHeight]);
  useEffect(() => {
    window.addEventListener('resize', scrollToBottom);
    return () => window.removeEventListener('resize', scrollToBottom);
  }, []);
  if (isLoading) return null;
  if (error) return <p>Error loading feedbacks</p>;

  return (
    <Box sx={{ width: '100%', boxShadow: 'none', height: '100%' }}>
      <List
        id="feedback-list-container"
        ref={listRef}
        sx={{
          overflow: 'auto',
          padding: 0,
          height: `calc(90vh - ${inputHeight + 45}px)`,
        }}
        onScroll={handleScroll}
      >
        {Object.entries(groupedFeedbacks).map(([date, feedbacks]) => (
          <React.Fragment key={date}>
            <StyledDateDivider date={date} />
            {feedbacks.map((feedback) => (
              <Element key={`feedback-${feedback._id}`} name={`feedback-${feedback._id}`}>
                <FeedbackItem feedback={feedback} user={user} setEditingFeedback={setEditingFeedback} />
              </Element>
            ))}
          </React.Fragment>
        ))}
      </List>
      {showScrollButton ? (
        <Tooltip title="Scroll to bottom" placement="left">
          <IconButton
            onClick={scrollToBottom}
            sx={{
              position: 'absolute',
              bottom: 15,
              right: 16,
              backgroundColor: 'lightgray',
              boxShadow: 1,
              '&:hover': {
                backgroundColor: 'grey.300',
              },
              zIndex: 1000,
              color: 'black',
            }}
          >
            <KeyboardArrowDown sx={{ m: '-5px' }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
  );
};

export default FeedbackList;
